'use client';

import { LiveQueryProvider } from '@sanity/preview-kit';
import { ReactNode, useRef } from 'react';
import { createClient } from '@sanity/client';
import { SanityDraftClientContext } from '@/components/context';

type Props = {
  token: string;
  children?: ReactNode;
};

export default function PreviewProvider({ token, children }: Props) {
  const client = createClient({
    token,
    apiVersion: '2024-02-24',
    projectId: process.env.SANITY_ID,
    dataset: process.env.SANITY_DATASET,
    useCdn: false,
    perspective: 'previewDrafts'
  });
  const ctxRef = useRef({ client });

  return (
    <SanityDraftClientContext.Provider value={ctxRef.current}>
      <LiveQueryProvider client={client}>{children}</LiveQueryProvider>
    </SanityDraftClientContext.Provider>
  );
}
